import "./App.scss";
import ErrorPage from "./pages/error/error";
import Game from "./pages/game/game";
import Login from "./pages/login/login";
import Leaderboard from "./pages/leaderboard/leaderboard";
import Layout from "./components/layout/layout";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { ThemeProvider } from "./services/theme";

const router = createBrowserRouter([
    {
        element: <Layout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: "/",
                element: <Game />,
            },
            {
                path: "/login",
                element: <Login />,
            },
            {
                path: "/leaderboard",
                element: <Leaderboard />,
            },
        ],
    },
]);

function App() {
    return (
        <ThemeProvider>
            <RouterProvider router={router} />
        </ThemeProvider>
    );
}

export default App;
